import { Component } from "@angular/core";

import { QuoteTabsActiveModeService } from '../../services/quoteTabsActiveMode/quoteTabsActiveMode.service';
import { quotePanelsTabsParams, QuotePanelsTabsList } from '../../enums/QuotePanelsTabs.list';

import { WorkspaceServiceService } from '../../services/workspace-service.service';
import { Alert } from "../../model/alert";
import { AlertState } from "../../enums/alert-state";
import * as $ from "jquery";
import { UserType } from "../../enums/USerType.enum";
import { DataService } from "../../services/data/data.service";

@Component({
    selector: "quotepanel-tabs",
    template: require('./quotePanelTabs.component.html'),
    styles: [
        require('./quotePanelTabs.component.css')
    ]
})

export class quotePanelTabs {

    tabs: object = quotePanelsTabsParams();

    constructor(private workspaceService: WorkspaceServiceService, public dataService: DataService) {
    }

    getFilteredTiles(): { id: string, label: string }[] {
        let tabsParams: { id: string, label: string }[] = Object.assign([], this.tabs)

        if (!this.dataService.AllowScannerAccess) {
            let scannerIndex = tabsParams.findIndex(x => x.id == QuotePanelsTabsList.SCANNER);
            if (scannerIndex > -1) {
                tabsParams.splice(scannerIndex, 1);
            }
        }

        return tabsParams;
    }

    isVisible(id: QuotePanelsTabsList): boolean {
        if (this.workspaceService.data.applicationUserType == UserType.Institutional && (id == QuotePanelsTabsList.ALERTS || id == QuotePanelsTabsList.LEADERBOARD)) {
            return false;
        } else {
            return true;
        }
    }



    get activeTab(): QuotePanelsTabsList {
        return this.workspaceService.data.activeTab;
    }

    set activeTab(tabId: QuotePanelsTabsList) {

        if (this.activeTab == QuotePanelsTabsList.LEADERBOARD) {
            this.workspaceService.data.loadLeaderBoards();
        }

        this.workspaceService.data.activeTab = tabId;


        window.location.hash = '#' + tabId;
        // $(window).attr('url').replace(anchor,'#food');

    }

    get numberOfAlerts() {
        if (this.workspaceService.data.alerts == null)
            return 0;
        return this.workspaceService.data.alerts.filter(a => this.workspaceService.data.getAlertState(a) == AlertState.Unread).length;
    }


}